import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, MapPin } from "lucide-react";
import { usePartner } from "@/context/PartnerAuthContext";
import { partnerApi, partnerCoverUrl } from "@/lib/partnerApi";
import { P_CARD, P_H1, P_EYEBROW, UrgentCard, PageLoading, ObraCover } from "@/components/partner/PartnerUI";

export default function PartnerHome() {
    const { partner } = usePartner();
    const [obras, setObras] = useState(null);

    useEffect(() => {
        partnerApi.get("/obras").then(({ data }) => setObras(data)).catch(() => setObras([]));
    }, []);

    const first = (partner?.contact_name || partner?.company_name || "").split(" ")[0];
    return (
        <>
            <div>
                <div className={P_EYEBROW}>{partner?.company_name}</div>
                <h1 className={`${P_H1} mt-2`} data-testid="partner-home-title">Olá, {first}.</h1>
                <p className="text-stone-600 mt-2 text-base">As minhas obras</p>
            </div>
            {obras === null ? <PageLoading /> : obras.length === 0 ? (
                <div className={`${P_CARD} text-center text-stone-600`} data-testid="partner-obras-empty">
                    De momento, não tem obras atribuídas.
                </div>
            ) : (
                <ul className="space-y-3" data-testid="partner-obras-list">
                    {obras.map((o) => <ObraCard key={o.lead_id} o={o} />)}
                </ul>
            )}
            <UrgentCard />
        </>
    );
}

function ObraCard({ o }) {
    const cover = partnerCoverUrl(o);
    return (
        <li>
            <Link to={`/parceiros/obras/${o.lead_id}`} className={`${P_CARD} group block overflow-hidden !p-0 hover:border-[hsl(var(--copper))]/50 transition-colors`} data-testid={`partner-obra-${o.lead_id}`}>
                <span className="block overflow-hidden">
                    <ObraCover key={cover} src={cover} className="w-full aspect-[16/7] sm:aspect-[16/5] transition-transform duration-500 group-hover:scale-[1.03]" testid={`partner-obra-cover-${o.lead_id}`} />
                </span>
                <span className="flex items-center gap-4 p-5">
                <span className="min-w-0 flex-1">
                    <span className="block font-display text-lg font-bold text-stone-900 leading-snug break-words">{o.title}</span>
                    {o.location && (
                        <span className="mt-1 flex items-center gap-1.5 text-[15px] text-stone-600"><MapPin className="w-4 h-4 flex-shrink-0" />{o.location}</span>
                    )}
                    <span className="mt-3 flex flex-wrap gap-2">
                        <span className="px-2.5 py-1 rounded-full text-xs font-semibold bg-stone-100 text-stone-700">{o.status}</span>
                        {o.changes_requested > 0 && <span className="px-2.5 py-1 rounded-full text-xs font-semibold bg-orange-100 text-orange-900">Correção pedida</span>}
                        {o.unread_replies > 0 && <span className="px-2.5 py-1 rounded-full text-xs font-semibold bg-[hsl(var(--copper))] text-white">Nova resposta</span>}
                    </span>
                </span>
                <span className="flex items-center gap-1 text-sm font-semibold text-[hsl(var(--copper))] whitespace-nowrap">
                    Ver obra <ChevronRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
                </span>
                </span>
            </Link>
        </li>
    );
}
